
    export default {
        computed: {
            services() {
                return this.$store.state.servicesData;
            },
        },
    };
